class ContextMenu {

    constructor(config = {}) {
        this.app = config.app;

        this.contextMenuItems = [
        {
            icon: 'upload',
            title: 'Move Up',
            class: null,
            action: this.ctxMoveNodeUp
        },
        {
            icon: 'download',
            title: 'Move Down',
            class: null,
            action: this.ctxMoveNodeDown
        },

        /*
        {
            icon: 'center_focus_weak',
            title: 'Center',
            class: null,
            action: ctxCenter
        },
        */

        {
            icon: 'copy_all',
            title: 'Duplicate',
            class: null,
            action: this.ctxDuplicate
        },

        /*
        {
            icon: 'flip',
            title: 'Flip Vertical',
            class: 'rotate90',
            action: ctxFlipVertical
        },
        {
            icon: 'flip',
            title: 'Flip Horizontal',
            class: null,
            action: ctxFlipHorizontal
        },

        {
            icon: 'rotate_left',
            title: 'Rotate Left',
            class: null,
            action: ctxRotateLeft
        },
        {
            icon: 'rotate_right',
            title: 'Rotate Right',
            class: null,
            action: ctxRotateRight
        },
        {
            icon: 'text_rotate_up',
            title: 'Increase Size',
            class: null,
            action: ctxIncreaseSize
        },
        {
            icon: 'text_rotate_vertical',
            title: 'Decrease Size',
            class: null,
            action: ctxDecreaseSize
        },
        */
        {
            icon: 'delete_forever',
            title: 'Delete',
            class: null,
            action: this.ctxDelete
        },
        ];

        this.init();
    }


    init() {
        // Create a div to use as a context menu
        const menuNode = document.createElement('div');
        menuNode.id = 'contextMenu';
        menuNode.style.position = 'fixed';
        menuNode.classList.add("contextMenu");


        // Create buttons for the menu
        const closeButton = document.createElement('button');
        closeButton.innerHTML = '<i class="material-icons-round">cancel</i>';
        closeButton.classList.add("contextMenuItem");
        closeButton.classList.add("right");
        closeButton.onclick = this.closeContentMenu;

        menuNode.appendChild(closeButton);

        this.contextMenuItems.forEach(mi => {
            let ctxButton = document.createElement('button');
            ctxButton.innerHTML = '<i class="material-icons-round">' + mi.icon + '</i>';
            ctxButton.classList.add("contextMenuItem");
            if (mi.class) {
                ctxButton.classList.add(mi.class);
            }
            ctxButton.title = mi.title;
            ctxButton.onclick = mi.action;

            menuNode.appendChild(ctxButton);
        });


        // Add buttons to menu
        document.body.appendChild(menuNode);

        // Hide menu on document click
        window.addEventListener('click', () => {
            //console.log('window clicked closeContentMenu');
            //closeContentMenu();
        });

        // Add context menu event
        this.app.getStage().on('contextmenu', function (e) {
            // prevent default behavior
            e.evt.preventDefault();
            if (e.target === this.app.getStage()) {
            // if we are on empty place of the stage we will do nothing
                return;
            }
            //currentShape = e.target;
            this.app.selectNode(e.target);

            // show menu
            menuNode.style.display = 'initial';
            const containerRect = this.app.getStage().container().getBoundingClientRect();
            menuNode.style.top = containerRect.top + this.app.getStage().getPointerPosition().y + 4 + 'px';
            menuNode.style.left = containerRect.left + this.app.getStage().getPointerPosition().x + 4 + 'px';
        }.bind(this));


        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                this.closeContentMenu();
            }
        });

    }
    
    
    closeContentMenu() {
        const menuNode = document.getElementById('contextMenu');
        if (menuNode) {
            menuNode.style.display = 'none';
        }
    }  


    ctxCenter() {
        this.closeContentMenu();
    }


    ctxDuplicate() {
        this.closeContentMenu();
    }


    ctxFlipVertical() {
        this.closeContentMenu();
        this.app.flipVertical(getSelectedNode());
    }


    ctxFlipHorizontal() {
        this.closeContentMenu();
        this.app.flipHorizontal(getSelectedNode());
    }


    ctxRotateLeft() {
        this.closeContentMenu();
        this.app.rotateObject(getSelectedNode(), -45);
    }


    ctxRotateRight() {
        this.closeContentMenu();
        this.app.rotateObject(getSelectedNode(), 45);
    }


    ctxIncreaseSize() {
        this.closeContentMenu();
        this.app.scaleObject(getSelectedNode(), 0.1);
    }

    
    ctxDecreaseSize() {
        this.closeContentMenu();
        this.app.scaleObject(getSelectedNode(), -0.1);
    }


    ctxDelete() {
        this.closeContentMenu();
        this.app.handleDeleteItem();
    }


    ctxMoveNodeDown() {
        this.closeContentMenu();
        this.app.moveSelectedNodeDown();
    }


    ctxMoveNodeUp() {
        this.closeContentMenu();
        this.app.moveSelectedNodeUp();
    }
}

